import React, { useState, useEffect, useRef } from 'react';
import { useMutation } from "@apollo/client";
import { GET_ADMINTRANSACTION_DETAILS } from "graphql/admin/mutations/transactions";
import { useHistory, useParams } from "react-router-dom";
import { Button, Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import sendMutationContext from "utils/sendContext";
import AdminNav from "./AdminNav";
import InvoiceCard from "./components/invoice/invoice.component";
import 'utils/jsdocTypes';
import { useReactToPrint } from "react-to-print";
import { formatDateMDYString } from "utils/date";
import { useAuth } from "components/custom/authprovider";

function PrintInvoice() {
  const [isCardLoaded, setIsCardLoaded] = useState(false);
  const componentRef = useRef();
  const handlePrintCfg = {
    contentRef: componentRef,
  };
  const handlePrint = useReactToPrint(handlePrintCfg);

  const history = useHistory();
  const transactionPath = (_ctransactionid) => {
    if (_ctransactionid) {
      return "/admin/tools/transaction-lookup/" + _ctransactionid;
    }

    return "/admin/tools/transaction-lookup";
  };

  const { wt } = useAuth();

  const [logoutFlag, setLogoutFlag] = useState();

  const { ctransactionid } = useParams();
  const [transactionID, setTransactionID] = useState("");

  /**
   * State variable for holding customer data.
   *
   * @type {[AdminTransactionDetails | undefined, React.Dispatch<React.SetStateAction<Transaction | undefined>>]}
   */
  const [customer, setCustomer] = useState();

  /**
   * State variable for holding transaction data.
   *
   * @type {[AdminTransactionDetails | undefined, React.Dispatch<React.SetStateAction<Transaction | undefined>>]}
   */
  const [transaction, setTransaction] = useState();

  const [adminTransactionLookup, { loading: loadingAdminTransactionLookup }] = useMutation(GET_ADMINTRANSACTION_DETAILS, sendMutationContext(wt, setLogoutFlag));

  const searchTransaction = async (searchTransactionId = undefined) => {
    if (!logoutFlag) {
      if (transactionID !== "") {
        searchTransactionId = transactionID;
      }

      if (!searchTransactionId || searchTransactionId == "") {
        setCustomer();
        setTransaction();
        return;
      }

      const data = await adminTransactionLookup({ variables: { transactionid: searchTransactionId } });
      if (data && data.data && data.data.adminTransactionLookup.error === null && searchTransactionId) {
        setCustomer(data.data.adminTransactionLookup.customer);
        setTransaction(data.data.adminTransactionLookup.transaction);
      } else {
        setCustomer();
        setTransaction();
      }
    }
  };

  useEffect(() => {
    if (ctransactionid) {
      setTransactionID(ctransactionid);
      searchTransaction(ctransactionid);
    }

    if (logoutFlag) {
      history.push("/admin/logout");
    }
  }, [logoutFlag, history]);

  useEffect(() => {
    if (isCardLoaded && componentRef.current) {
      handlePrintCfg["documentTitle"] = `Invoice_${formatDateMDYString(transaction.datetimecreated)}_${transaction.referenceid1}`;
      handlePrint();
    }
  }, [isCardLoaded]);

  return (
    <div className="admin-wrapper">
      <AdminNav />

      <Container fluid className="content">
        <Row>
          <Col>
            <Card className="card-dark">
              <CardHeader className="card-header-dark">
                <Row>
                  <Col lg="8" md="6" sm="6">
                    Transaction Invoice
                  </Col>

                  <Col lg="2" md="3" sm="3" style={{ textAlign: "right" }}>
                    <Button
                      color="success"
                      className="toggle-status-btn"
                      onClick={() => history.push(transactionPath(ctransactionid))}
                    >
                      Back to Transaction Lookup
                    </Button>
                  </Col>

                  <Col lg="2" md="3" sm="3" style={{ textAlign: "right" }}>
                    {isCardLoaded ? (
                      <Button
                        color={"success"}
                        onClick={handlePrint}
                      >
                        Print Invoice
                      </Button>
                    ) : (
                        <Button
                          color={"success"}
                          disabled
                        >
                          Print Invoice
                        </Button>
                      )
                    }
                  </Col>
                </Row>
              </CardHeader>
            </Card>
            {!transaction && !loadingAdminTransactionLookup &&
              <CardBody className="content">
                <span>No transaction found!</span>
              </CardBody>
            }

            {loadingAdminTransactionLookup &&
              <CardBody className="content">
                <span>Loading transaction invoice...</span>
              </CardBody>
            }

            {!loadingAdminTransactionLookup && transaction && customer &&
              <InvoiceCard transaction={transaction} customer={customer} onCardLoad={() => setIsCardLoaded(true)} ref={componentRef} />
            }
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default PrintInvoice;